import styled, { css } from 'styled-components';

import { mobileCssQuerist, spacing, transparencies } from 'styles/theme';

export const BottomMenuWrapper = styled.div`
    position: fixed;
    z-index: 100;
    bottom: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
`;

interface MenuItemWrapperProps {
    $isSelected: boolean;
}

export const MenuItemWrapper = styled.div<MenuItemWrapperProps>`
    border-radius: ${spacing.radiusSmall};
    background-color: transparent;
    padding: ${spacing.small};
    display: flex;
    justify-content: space-between;
    transition: background-color 0.2s;

    ${(props) =>
        props.$isSelected
            ? css`
                  background-color: ${transparencies.mountainAsh10};
              `
            : css`
                  &:hover {
                      background-color: ${transparencies.darkJungle5};
                  }
              `}

    ${mobileCssQuerist(css`
        padding: ${spacing.xSmall} ${spacing.small};
        background-color: transparent;

        &:hover {
            background-color: transparent;
        }
    `)}
`;

export const ItemContentWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;

    ${mobileCssQuerist(css`
        flex-direction: column;
    `)}
`;

interface ItemIconWrapperProps {
    $isSelected: boolean;
    $isImageAsset: boolean;
}

export const ItemIconWrapper = styled.div<ItemIconWrapperProps>`
    margin: 0 ${spacing.xSmall} 0 0;
    display: flex;
    transition: transform 0.3s ease-in-out;

    ${(props) =>
        props.$isImageAsset
            ? props.$isSelected
                ? css`
                      transform: rotate(0deg);
                  `
                : css`
                      transform: rotate(90deg);
                  `
            : null}

    ${mobileCssQuerist(css`
        margin: 0 0 ${spacing.xxxSmall} 0;
    `)}
`;
